import { PARTNERS } from "@/lib/site";

export const PartnerBadges = () => {
  // Duplicate the list so the marquee loops seamlessly.
  const loop = [...PARTNERS, ...PARTNERS];

  return (
    <section
      data-testid="partner-badges"
      className="bg-white border-t border-brand-line overflow-hidden"
      aria-label="Partners and regulators"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14 relative">
        {/* Left / right fade masks */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 lg:w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 lg:w-24 bg-gradient-to-l from-white to-transparent z-10" />

        <div
          className="marquee flex items-center gap-14 lg:gap-20 min-w-full w-max"
          role="list"
        >
          {loop.map((p, i) => (
            <div
              key={`${p.short}-${i}`}
              data-testid={
                i < PARTNERS.length
                  ? `partner-${p.short.toLowerCase().replace(/\s+/g, "-")}`
                  : undefined
              }
              role="listitem"
              className="shrink-0 flex items-center justify-center"
              title={p.name}
              aria-hidden={i >= PARTNERS.length ? "true" : undefined}
            >
              <img
                src={p.url}
                alt={i < PARTNERS.length ? p.name : ""}
                style={{
                  maxHeight: `${(p.scale || 1) * 6}rem`,
                }}
                className="w-auto object-contain opacity-90 hover:opacity-100 transition-opacity duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .marquee {
          animation: partners-marquee 40s linear infinite;
        }
        .marquee:hover {
          animation-play-state: paused;
        }
        @keyframes partners-marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee { animation: none; }
        }
      `}</style>
    </section>
  );
};
